import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ProfileService } from './profile.service';
import { NewUserDialogComponent } from './new-user-dialog/new-user-dialog.component';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeleteUserDialogComponent } from './delete-user-dialog/delete-user-dialog.component';
import { EditProfileDialogComponent } from './edit-profile-dialog/edit-profile-dialog.component';
import { RouterModule } from '@angular/router';
import { EditProfileTabComponent } from './edit-profile-tab/edit-profile-tab.component';
import { MatSelectModule, MatInputModule } from '@angular/material';
import { NewUserPermissionsComponent } from './new-user-dialog/new-user-permissions/new-user-permissions.component';
import { LoadingModule } from 'ngx-loading';
import { ProfileTabComponent } from './profile-tab/profile-tab.component';
import { ProfileUsersComponent } from './profile-users/profile-users.component';
import { ProfileComponent } from './profile.component';
import { ProfileHouseComponent } from './profile-house/profile-house.component';
import {MatStepperModule, MatStepper} from '@angular/material/stepper';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { EditAddressDialogComponent } from './edit-address-dialog/edit-address-dialog.component';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    RouterModule,
    MatSelectModule,
    LoadingModule,
    MatStepperModule,
    MatInputModule,
    MatProgressBarModule,
  ],
  entryComponents: [
    NewUserDialogComponent,
    DeleteUserDialogComponent,
    EditProfileDialogComponent,
    EditAddressDialogComponent
  ],
  providers: [ProfileService],
  declarations: [
    NewUserDialogComponent,
    DeleteUserDialogComponent,
    EditProfileDialogComponent,
    EditProfileTabComponent,
    NewUserPermissionsComponent,
    ProfileComponent,
    ProfileTabComponent,
    ProfileUsersComponent,
    ProfileHouseComponent,
    EditAddressDialogComponent,
    ProfileDetailsComponent
  ]
})
export class ProfileModule { }



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile.module.ts